<template>
  <p class="mt-2 text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
    <slot/>
  </p>
</template>
